<template>
  <AccessDenied
    v-if="!permissaoTela.visualizar"
    msg="Você não tem permissão para visualizar esta tela. Caso precise de acesso, procure o suporte."
  />
  <GridIndex v-else />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import AccessDenied from '@/views/auth/AccessDenied.vue';
  import GridIndex from './components/GridIndex.vue';
  import { eTipoPermissao } from '@/enums/ePermissoes';
  import {
    PERMISSAO_TELA_INJECT_KEY,
    PermissaoTela,
    resolverPermissaoTela,
  } from '@/composables/usePermissaoTela/usePermissaoTela';

  export default defineComponent({
    name: 'SalaIndex',
    components: { AccessDenied, GridIndex },
    provide() {
      return {
        [PERMISSAO_TELA_INJECT_KEY]: this.permissaoTela,
      };
    },
    computed: {
      permissaoTela(): PermissaoTela {
        return resolverPermissaoTela(this.$route.meta?.permissions as eTipoPermissao[] | undefined);
      },
    },
  });
</script>
